// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout-specific styles */

/* Main content layout styles */
.page-container {
  max-width: 80rem; /* max-w-7xl */
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem;
  padding-top: 2rem; /* py-8 */
  padding-bottom: 2rem;
}

@media (min-width: 640px) {
  .page-container {
    padding-left: 1.5rem; /* sm:px-6 */
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px) {
  .page-container {
    padding-left: 2rem; /* lg:px-8 */
    padding-right: 2rem;
  }
}

.section {
  margin-top: 3rem; /* my-12 */
  margin-bottom: 3rem;
}

/* Hero section layout */
.hero {
  position: relative;
  overflow: hidden;
  background-color: #1a2f4d; /* orthodox-blue-800 */
  color: white;
}

.hero-content {
  position: relative;
  z-index: 10;
  padding-top: 4rem; /* py-16 */
  padding-bottom: 4rem;
  max-width: 80rem; /* max-w-7xl */
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem;
}

@media (min-width: 768px) {
  .hero-content {
    padding-top: 6rem; /* md:py-24 */
    padding-bottom: 6rem;
  }
}

@media (min-width: 1024px) {
  .hero-content {
    padding-top: 8rem; /* lg:py-32 */
    padding-bottom: 8rem;
    padding-left: 2rem; /* lg:px-8 */
    padding-right: 2rem;
  }
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background-color: black;
  opacity: 0.5;
}

/* Dropdown item styling */
.dropdown-item-dark {
  color: #f3f4f6;
  background-color: #1f2937;
}`, "",{"version":3,"sources":["webpack://./src/styles/layouts/index.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B,+BAA+B;AAC/B;EACE,gBAAgB,EAAE,cAAc;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAE,SAAS;EAC7B,mBAAmB;EACnB,iBAAiB,EAAE,SAAS;EAC5B,oBAAoB;AACtB;;AAEA;EACE;IACE,oBAAoB,EAAE,YAAY;IAClC,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB,EAAE,YAAY;IAChC,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB,EAAE,UAAU;EAC5B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAE,sBAAsB;EACjD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAE,UAAU;EAC7B,oBAAoB;EACpB,gBAAgB,EAAE,cAAc;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAE,SAAS;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB,EAAE,aAAa;IAChC,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,aAAa;IAChC,oBAAoB;IACpB,kBAAkB,EAAE,YAAY;IAChC,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* Layout-specific styles */\n\n/* Main content layout styles */\n.page-container {\n  max-width: 80rem; /* max-w-7xl */\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem; /* px-4 */\n  padding-right: 1rem;\n  padding-top: 2rem; /* py-8 */\n  padding-bottom: 2rem;\n}\n\n@media (min-width: 640px) {\n  .page-container {\n    padding-left: 1.5rem; /* sm:px-6 */\n    padding-right: 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .page-container {\n    padding-left: 2rem; /* lg:px-8 */\n    padding-right: 2rem;\n  }\n}\n\n.section {\n  margin-top: 3rem; /* my-12 */\n  margin-bottom: 3rem;\n}\n\n/* Hero section layout */\n.hero {\n  position: relative;\n  overflow: hidden;\n  background-color: #1a2f4d; /* orthodox-blue-800 */\n  color: white;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 10;\n  padding-top: 4rem; /* py-16 */\n  padding-bottom: 4rem;\n  max-width: 80rem; /* max-w-7xl */\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem; /* px-4 */\n  padding-right: 1rem;\n}\n\n@media (min-width: 768px) {\n  .hero-content {\n    padding-top: 6rem; /* md:py-24 */\n    padding-bottom: 6rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .hero-content {\n    padding-top: 8rem; /* lg:py-32 */\n    padding-bottom: 8rem;\n    padding-left: 2rem; /* lg:px-8 */\n    padding-right: 2rem;\n  }\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background-color: black;\n  opacity: 0.5;\n}\n\n/* Dropdown item styling */\n.dropdown-item-dark {\n  color: #f3f4f6;\n  background-color: #1f2937;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
